import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Modal, Switch, TextStyle } from "@rentiohq/web-shared/dist/components";
import { IAction } from "@rentiohq/web-shared/dist/types";
import React from "react";
import * as S from "./CreateInvoiceWithConfirmModal.styled";

export enum EInvoiceSendingMethod {
  Email = "EMAIL",
  Peppol = "PEPPOL",
}

interface IProps {
  onConfirm: (deliveryMethods: EInvoiceSendingMethod[]) => void;
  onClose: () => void;
}

export const CreateInvoiceWithConfirmModal = (params: IProps) => {
  const { onConfirm, onClose } = params;

  const [selectedDeliveryMethods, setSelectedDeliveryMethods] = React.useState<
    EInvoiceSendingMethod[]
  >([]);

  const handleSelectDeliveryMethod = ({
    method,
    selected,
  }: {
    method: EInvoiceSendingMethod;
    selected: boolean;
  }) => {
    if (!selected) {
      setSelectedDeliveryMethods(
        selectedDeliveryMethods.filter(
          selectedMethod => selectedMethod !== method,
        ),
      );
    }

    if (selected) {
      setSelectedDeliveryMethods([...selectedDeliveryMethods, method]);
    }
  };

  const modalActions: IAction[] = [
    {
      content: getLocalizedText("cancel"),
      type: "submit",
      onClick: onClose,
      appearance: "outline",
    },
    {
      content:
        selectedDeliveryMethods.length > 0
          ? getLocalizedText("revenues.create_invoice.cta.create_and_send")
          : getLocalizedText("revenues.create_invoice.cta.without_email"),
      type: "submit",
      onClick: () => onConfirm(selectedDeliveryMethods),
      appearance: "primary",
    },
  ];

  const methods = [
    {
      id: EInvoiceSendingMethod.Email,
      title: getLocalizedText(
        `create_invoice.delivery_method.${EInvoiceSendingMethod.Email}.title`.toLowerCase(),
      ),
    },
    {
      id: EInvoiceSendingMethod.Peppol,
      title: getLocalizedText(
        `create_invoice.delivery_method.${EInvoiceSendingMethod.Peppol}.title`.toLowerCase(),
      ),
      description: getLocalizedText(
        `create_invoice.delivery_method.${EInvoiceSendingMethod.Peppol}.description`.toLowerCase(),
      ),
    },
  ];

  return (
    <Modal
      width={"medium"}
      heading={getLocalizedText("revenues.create_invoice.confirm.title")}
      onClose={onClose}
      actions={modalActions}
      shouldCloseOnOverlayClick={false}
    >
      <S.Wrap>
        {methods.map(method => {
          const { id, title, description } = method;
          return (
            <S.Row key={id}>
              <S.RoleCell>
                <TextStyle variation="strong" size="medium" element="div">
                  {title}
                </TextStyle>
                {description && (
                  <TextStyle variation="subdued">{description}</TextStyle>
                )}
              </S.RoleCell>
              <S.Cell>
                <Switch
                  onChange={value =>
                    handleSelectDeliveryMethod({ method: id, selected: value })
                  }
                  isChecked={selectedDeliveryMethods.includes(id)}
                />
              </S.Cell>
            </S.Row>
          );
        })}
      </S.Wrap>
    </Modal>
  );
};
